export enum LoanType {
	DirectSales = 'DirectSales',
	CreditLine = 'CreditLine',
	Other = 'Other',
	Cash = 'Cash',
	SmallLoan = 'SmallLoan',
	CarLoan = 'CarLoan',
	RefinancingLoan = 'RefinancingLoan',
	MortgageLoan = 'MortgageLoan',
	RenovationLoan = 'RenovationLoan',
}

export enum SortPropType {
	agreementNumber = 'agreementNumber',
	unpaidInvoices = 'unpaidInvoices',
	externalPartnerName = 'externalPartnerName',
	latestDisbursementDate = 'latestDisbursementDate',
}

export enum ProductType {
	FinHalens = 'FinHalens',
	FinCredento = 'FinCredento',
	SweHalens = 'SweHalens',
	SweCredento = 'SweCredento',
	PolCredento = 'PolCredento',
	EstTfbank = 'EstTfbank',
	NorCredento = 'NorCredento',
	PolDirectSales = 'PolDirectSales',
	EstCreditLine = 'EstCreditLine',
	EstCreditLineInvoice = 'EstCreditLineInvoice',
	EstDirectSales = 'EstDirectSales',
	LvaCashLoan = 'LvaCashLoan',
	EstCarLoan = 'EstCarLoan',
	LvaCarLoan = 'LvaCarLoan',
	LtuCashLoan = 'LtuCashLoan',
	AutCashLoan = 'AutCashLoan',
	SweCashLoan = 'SweCashLoan',
	LtuDirectSales = 'LtuDirectSales',
	LtuCarLoan = 'LtuCarLoan',
	LtuRenovation = 'LtuRenovation',
	DeuCreditCard = 'DeuCreditCard',
	EstRefin = 'EstRefin',
	LvaRefin = 'LvaRefin',
	LtuRefin = 'LtuRefin',
	FinRefin = 'FinRefin',
	EstMortgage = 'EstMortgage',
	LvaDirectSales = 'LvaDirectSales',
	LtuCreditLine = 'LtuCreditLine',
	LvaCreditLine = 'LvaCreditLine',
	LtuCreditLineTf = 'LtuCreditLineTf',
	LvaCreditLineTf = 'LvaCreditLineTf',
	EstCreditLineTf = 'EstCreditLineTf',
	DnkCashLoan = 'DnkCashLoan',
	EspCashLoan = 'EspCashLoan',
	EspCreditCard = 'EspCreditCard',
	NorRefin = 'NorRefin',
	FinCashLoan = 'FinCashLoan',
	FinHalensLoan = 'FinHalensLoan',
	FinRefinLoan = 'FinRefinLoan',
	FinRefinPpi = 'FinRefinPpi',
	FinHalensLoanPpi = 'FinHalensLoanPpi',
	FinCashLoanPpi = 'FinCashLoanPpi',
	FinRefinLoanPpi = 'FinRefinLoanPpi',
}

export enum PaymentReliefTypes {
	PaymentHolidayWithInterestAndFees = 'PaymentHolidayWithInterestAndFees',
	PaymentHolidayCumulatedInterest = 'PaymentHolidayCumulatedInterest',
	PaymentHolidayNordic = 'PaymentHolidayNordic',
	SkipCollection = 'SkipCollection',
	MixedPricing = 'MixedPricing',
	PaymentHolidayWithSplitInterest = 'PaymentHolidayWithSplitInterest',
	AutomaticPaymentHolidayNordic = 'AutomaticPaymentHolidayNordic',
	FreePPI = 'FreePPI',
	PaymentHolidayWithoutInterestAndFees = 'PaymentHolidayWithoutInterestAndFees',
	PayInterestOnFirstInvoices = 'PayInterestOnFirstInvoices',
	MixedPricingDPD = 'MixedPricingDPD',
	AutomaticPaymentHolidayCumulatedInterest = 'AutomaticPaymentHolidayCumulatedInterest ',
	PaymentHolidayCumulatedInterestAndFee = 'PaymentHolidayCumulatedInterestAndFee',
}
